module.exports = __webpack_public_path__ + "media/wood_7.507aa5a6.webm";